export const GAME_DESCRIPTIONS = {
  NAME_VALIDATOR: {
    title: "🦒👋",
    description:
      "Let's validate whether you are the right person to access this gift box! </br></br> Enter your name to begin your journey!",
  },
  DATE_VALIDATOR: {
    title: "First walk? 💃",
    description:
      "Sorry, couldn't really give you progress for knowing your name.. </br></br> Now let's validate the date of our first walk! </br></br> Shouldn't be to difficult as we've spoken about this just recently!",
  },
  WORDS_MINIGAME: {
    title: "Time to start working on that mind of yours!",
    description:
      "I'm going to throw a bunch of word combinations at you. </br></br> You make sure you finish them correctly!",
  },
  OPTION_MINIGAME: {
    title: "My favourites!",
    description:
      "Do you even know me? I'll present you with a couple of questions and you'll decide. </br></br> Guess what? You'll get it right!",
  },
  ODD_ONE_OUT: {
    title: "Odd One Out",
    description: "Guess you know what to do by now..",
  },
  SONG_SNIPPET: {
    title: "Song Snippet",
    description:
      "Put your music knowledge to the test! You'll hear or see a snippet of song lyrics. Guess the song title or artist name to continue. Don't worry if you're not sure - give it your best guess!",
  },
  PUZZLE_BOX: {
    title: "Puzzle Box",
    description:
      "Let's see whether you can take on a real challange! </br></br> You'll be finished and rewarded after this one..",
  },
};
